import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUnit } from "effector-react";
import { $authStore } from "../../features/auth/store/auth";
import { ROUTES } from "../constants/app";
import Loader from "../components/loader/Loader";
import Layout from "@/features/app/components/layout/Layout";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const authState = useUnit($authStore);
  const location = useLocation();

  // Safe extraction of authentication state
  const { isAuthenticated, loading } = React.useMemo(() => {
    try {
      return {
        isAuthenticated: Boolean(authState?.isAuthenticated),
        loading: Boolean(authState?.loading),
      };
    } catch (error) {
      console.warn("PrivateRoute state extraction error:", error);
      return {
        isAuthenticated: false,
        loading: false,
      };
    }
  }, [authState]);

  // Show loading while checking authentication
  if (loading) {
    return <Loader message="Checking authentication..." />;
  }

  // If not authenticated, redirect to login with return URL
  if (!isAuthenticated) {
    // Store the current URL for redirect after login
    const returnUrl = location.pathname + location.search + location.hash;
    //console.log('PrivateRoute: Storing returnUrl:', returnUrl);
    sessionStorage.setItem("returnUrl", returnUrl);

    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // If authenticated, render with layout
  return <Layout>{children}</Layout>;
};

export default PrivateRoute;
